import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import Button from "../Button/Button";
import TextInput from "../TextInput/TextInput";
import { IBlackUser } from "../../../../store/types/userTypes";
import { isFullAccessRestriction } from "../../../../views/LogisticPark/RegistroIngreso/utils/blacklistRestriction";
import "./BlacklistDialog.css";

type BlacklistDialogProps = {
  open: boolean;
  blacklistedData: IBlackUser | null | undefined;
  onReject: () => void;
  onAllow: (authorizedBy: string) => void;
};

const BlacklistDialog: React.FC<BlacklistDialogProps> = ({
  open,
  blacklistedData,
  onReject,
  onAllow,
}) => {
  const [isAllowing, setIsAllowing] = useState(false);
  const [authorizedBy, setAuthorizedBy] = useState("");
  const blacklistedDni = blacklistedData?.dni;

  useEffect(() => {
    if (open) {
      setIsAllowing(false);
      setAuthorizedBy("");
    }
  }, [open, blacklistedDni]);

  const isTotalRestriction = isFullAccessRestriction(blacklistedData);

  return (
    <Dialog
      open={open}
      onClose={onReject}
      PaperProps={{ className: "blacklistDialogCard", elevation: 2 }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="blacklistDialogTitle">
        <span className="blacklistDialogTitleMain">
          {`El documento ${blacklistedData?.dni ?? ""} tiene una restricción de acceso.`}
        </span>
        <span className="blacklistDialogTitleSub">
          {`Cargado por: ${blacklistedData?.blacklistedBy ?? ""}`}
        </span>
      </DialogTitle>
      <DialogContent className="blacklistDialogContent">
        <span className="blacklistDialogField">Nombre: {blacklistedData?.firstname}</span>
        <span className="blacklistDialogField">Apellido: {blacklistedData?.lastname}</span>
        <span className="blacklistDialogField">Motivo: {blacklistedData?.reason}</span>
        {isTotalRestriction && (
          <span className="blacklistDialogWarning">
            Este documento tiene una restricción total de acceso. No es posible continuar
            mientras esta restricción esté activa.
          </span>
        )}
      </DialogContent>
      <DialogActions className="blacklistDialogActions">
        <Button variant={isTotalRestriction ? "success" : "error"} onClick={onReject}>
          {isTotalRestriction ? "Aceptar" : "Rechazar registro"}
        </Button>
        {!isTotalRestriction && !isAllowing && (
          <Button variant="success" onClick={() => setIsAllowing(true)}>
            Permitir registro
          </Button>
        )}
      </DialogActions>
      {!isTotalRestriction && isAllowing && (
        <DialogContent className="blacklistDialogAuthorizerSection">
          <TextInput
            label="Responsable que autoriza este registro"
            value={authorizedBy}
            onChange={setAuthorizedBy}
            placeholder="Nombre y apellido"
          />
          <Button
            variant="success"
            disabled={!authorizedBy.trim()}
            onClick={() => onAllow(authorizedBy.trim())}
          >
            Confirmar registro
          </Button>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default BlacklistDialog;
